var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay } from '@xyo-network/sdk-xyo-js';
import global from '../../global';
class Rdt {
    static init(pixelId) {
        try {
            Rdt.instance = new Rdt();
            Rdt.instance.load(pixelId);
            Rdt.instance.track('PageVisit');
        }
        catch (ex) {
            console.error(ex);
        }
    }
    static getRdt() {
        return global.rdt;
    }
    load(id) {
        try {
            Rdt.getRdt()('init', id);
        }
        catch (ex) {
            console.error(ex);
        }
    }
    track(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                Rdt.getRdt()('track', event, Object.assign({}, data));
                yield delay(0);
            }
            catch (ex) {
                console.error(ex);
            }
        });
    }
}
export default Rdt;
//# sourceMappingURL=Rdt.js.map